import { createComponent } from '@/internals/utils';

export const ImageWrapper = createComponent({ name: 'ImageWrapper', componentAs: 'div' });
